import classNames from 'classnames';
import { FC, HTMLAttributes, type JSX } from 'react';

import { Typography } from '@/shared/ui/Typography';

import { NullValueGuard } from '@/middlewares/NullValueGuard';

import { ConditionView } from '../../ConditionView/ConditionView';
import { Truncatable } from '../../Truncatable/Truncatable';

export interface Row {
  label: string;
  value: Nullable<string | number | JSX.Element>;
  dataTestId: string;
  isColFull?: boolean;
  isValueTruncatable?: boolean;
}

interface Props extends HTMLAttributes<HTMLDivElement> {
  rows: Row[];
}

export const RowRenderer: FC<Props> = ({ rows, className, ...restProps }) => {
  return (
    <>
      {rows.map(
        ({ label, value, dataTestId, isColFull, isValueTruncatable }): JSX.Element => (
          <div
            {...restProps}
            key={label}
            className={classNames(
              'service-row-card__col',
              {
                'service-row-card__col--full': isColFull,
              },
              className,
            )}
          >
            <Typography color="graphite" variant="TEXT14" className="service-row-card__col-title" semibold>
              {label}
            </Typography>
            <div data-testid={dataTestId} className="service-row-card__col-text">
              <ConditionView if={Boolean(isValueTruncatable)} else={<NullValueGuard>{value}</NullValueGuard>}>
                <Truncatable
                  lines={3}
                  text={
                    <Typography className="service-row-card__col-text">
                      <NullValueGuard>{value}</NullValueGuard>
                    </Typography>
                  }
                />
              </ConditionView>
            </div>
          </div>
        ),
      )}
    </>
  );
};
